import React from "react";
import {RefreshCw} from "lucide-react";

export default function RefreshIconButton({onClick,disabled=false,loading=false,label="Refresh"}) {
 return <button type="button" onClick={onClick} disabled={disabled||loading}
  aria-label={label} title={label} aria-busy={loading}
  className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-500 transition hover:border-cyan-300 hover:bg-cyan-50 hover:text-cyan-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-cyan-600 disabled:cursor-default disabled:opacity-40">
  <RefreshCw aria-hidden="true" className={loading?"h-4 w-4 animate-spin":"h-4 w-4"}/>
 </button>;
}
